import * as types from './../actions/actionTypes.js';
import initialState from './initialState';
import {getPaginationPageCount} from "./ui.patterngallery";
import makeQuery from "../helper/Query"

// Set the query string for an api call. Merges the resulted data in the patterns
// Entity cache.
const query = ( state, locale, action ) => {

    const patternQueryResultFields = 'id,title,description,keywords,thumbnails.repeat,thumbnails.gallery,thumbnails.medium,thumbnails.xlarge,thumbnails.xlargeDiscreet,thumbnailDimensions,metadata.recolorable,designer.id,designer.name,designer.display,designer.profileUrl';
    const language = {language: locale};

    let newState = {};

    switch ( action.type ) {

        case types.QUERY_MODIFIED:
            return Object.assign( {}, initialState.currentQuery,
                action.query, language );

        case types.PATTERN_QUERY_MODIFIED:
            newState = Object.assign( {}, initialState.currentQuery, {
                    resultFields: patternQueryResultFields,
                }, action.query, language
            );
            newState = Object.defineProperties( newState, {
                'totalHits': {value: 0, writable: true},
                'fetched'  : {value: 0, writable: true}
            } );
            return newState;

        case types.SEARCHSTRING_SETTED:
            newState = Object.assign( {}, initialState.currentQuery, {
                    resultFields: patternQueryResultFields
                }, action.query, language
            );
            newState = Object.defineProperties( newState, {
                'totalHits': {value: 0, writable: true},
                'fetched'  : {value: 0, writable: true}
            } );
            return newState;

        case types.PATTERNS_RECEIVED:
            newState = Object.assign( {}, state );
            newState = Object.defineProperties( newState, {
                'totalHits': {
                    value: action.response.result.totalHits, writable: true
                },
                'fetched'  : {
                    value   : state.fetched + action.response.result.patterns.length,
                    writable: true
                }
            } );
            return newState;

        case types.LOCALE_CHANGED:
            newState = Object.assign( {}, state, {
                    language: (action.currentLanguage || 'de'),
                }
            );
            newState = Object.defineProperties( newState, {
                'totalHits': {value: 0, writable: true},
                'fetched'  : {value: 0, writable: true}
            } );
            return newState;

        case types.LOCALE_SETTED_FROM_URI:
            newState = Object.assign( {}, state, {
                    language: (action.language || 'de'),
                }
            );
            newState = Object.defineProperties( newState, {
                'totalHits': {value: 0, writable: true},
                'fetched'  : {value: 0, writable: true}
            } );
            return newState;

        default:
            return state;
    }
};

export default query;

export const getResultTotal = (state) => state.stolo.currentQuery.totalHits;

export const getCurrentQuery = ( state ) => state.stolo.currentQuery;

export const getQueryString = ( state ) => {
    const query = makeQuery(getCurrentQuery(state));
    return query.getQueryString();
};

export const getQueryCacheKey = ( state ) => {
    const query = makeQuery(getCurrentQuery(state));
    return query.getHash();
};



// WEBPACK FOOTER //
// ./src/reducers/query.js